<template>
<f7-page class="page" id="notification-detail-page" name="notification-detail-page" @page:afterin="afterin();">
    <f7-navbar class="view-mobile no-border">
        <f7-nav-left class="back-button">
            <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
    </f7-navbar>

    <f7-block>
        <div class="col-70 text-align-left mb-20">
            <div class="wandr-title-1">{{$t('general-text-notification')}}</div>
        </div>
        <div class="static-content wandre-box" v-if="isLoaded">
            <div @click="handleSetTransactionId()" class="notification-subject">{{message.subject}}</div>
            <div class="fs-14 fw-medium" @click="handleSetTransactionId()" v-html="messageContent"></div>

		</div>
    </f7-block>
    <f7-toolbar position="bottom" no-hairline class="toolbar-with-stacked-button view-mobile">
        <f7-button large fill @click="navigateToHome()">
            {{$t('general-text-back-to-home')}}
        </f7-button>
    </f7-toolbar>
</f7-page>
</template>

<script>
    import { mapActions } from "vuex"
    export default {
        data() {
            return {
                message        : "",
                messageContent : "",
                routerTo       : "/notification/detail",
                isLoaded       : false
            }
        },
        mounted (){
            const self = this;
            self.showPreloader()
            // Required for everypage. Toggle desktop-view footer.
            this.toggleFooterVisibility(false)
            this.$f7.$('.page-content').on('scroll', (e) => {
                this.toggleFooterVisibility(e.target)
            })

            self.message = self.$store.state.misc.message;
            if(self.message != '' && self.message != undefined){
                self.handleMarkMessageAsSeen()
                self.messageContent = self.message.content
            }
        },
        methods:{
            ...mapActions('customer', [
                'launchNotification',
            ]),

            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },
            async handleMarkMessageAsSeen(){
                const messageIds = [this.message.id]
                await this.$api.customer.updateInboxMessageAsRead(messageIds)
                this.launchNotification()
                this.isLoaded = true;
            },

            handleSetTransactionId(){
                if(this.message.subject != undefined && this.message.subject.length > 0 ){
                    var id = "";

                    if(this.message.subject.indexOf("no.") > -1){

                        try{
                            //check if message subject contains a word that only numbers which is the trx id
                            let words = this.message.subject.split(' ').filter(w => w.match(/^[0-9]+$/) != null);

                            if(words != undefined && words.length >0){
                                console.log(words)
                                id = words[0]
                                this.navigateToTransactionDetail(id);

                            }
                        }catch (e){
                            //remove all chars and get only numbers
                            id =  this.message.subject.replace(/[^\d]/g, '')
                            console.log("TRX ID",id)

                            if(!isNaN(id)) {
                                this.navigateToTransactionDetail(id);
                            }
                        }

                    }else if(this.message.subject.indexOf("#") > -1){
                        //check if subject contains '#' which also indicates trx id
                        id = this.message.subject.substring(this.message.subject.indexOf("#") + 1, this.message.subject.lastIndexOf(" has") );

                        console.log("TRX ID",id)
                        if(isNaN(id)) {
                            id = this.message.subject.substring( this.message.subject.indexOf("#") + 1, this.message.subject.length );
                        }
                        if(!isNaN(id)) {
                            this.navigateToTransactionDetail(id);
                        }

                    }
                }

            },

            navigateToTransactionDetail(transactionId){
                const self                     = this
                var transaction                = self.$store.state.transaction
                transaction.transactionId      = transactionId
                transaction.routerTo           = self.routerTo
                transaction.isFromNotification = true
                self.$f7router.navigate("/transaction-history-details", { transition: 'f7-push' });
            },

            navigateToHome(){
                this.$f7router.navigate("/home", { transition: 'f7-fade', clearPreviousHistory  : true });

            },

            backButton() {
                this.$f7router.back({ transition: 'f7-push' });
            },
        }
    }
</script>